import { FC } from 'react';
import type { VirtualItem } from '@tanstack/react-virtual';
import type {
  DataTableColumn,
  DataTableColumnGroupingData,
  DataTableDimensions,
} from '@/components/UI/DataTableV2/DataTable.model';
import { DataTableColumnHeader } from './DataTableColumnHeader';
import { useDataTable } from '../DataTableProvider';
import cn from 'classnames';
import styles from '../DataTableV2.module.scss';

interface ScrollableColumnHeadersProps {
  virtualColumns: Array<VirtualItem>;
  scrollableColumns: Array<DataTableColumn>;
  stickyColumnCount: number;
  groupHeaderHeight: number;
  dimensions: DataTableDimensions;
  columnGroupingData?: DataTableColumnGroupingData | null;
}

export const ScrollableColumnHeaders: FC<ScrollableColumnHeadersProps> = ({
  virtualColumns,
  scrollableColumns,
  stickyColumnCount,
  groupHeaderHeight,
  dimensions,
  columnGroupingData,
}) => {
  const { dataTableService } = useDataTable();

  return (
    <>
      {virtualColumns.map((virtualColumn) => {
        const column = scrollableColumns[virtualColumn.index];
        const columnIndex = dataTableService.toIndexColumn(column.id);

        if (columnIndex === undefined) {
          return null;
        }

        const isGrouped = columnGroupingData?.columnGroupMap.has(columnIndex) ?? false;
        const hasGroupBorder = dataTableService.rightBorderType(columnIndex) === 'group-separator';

        return (
          <div key={column.id}>
            {/* Render placeholder for non-grouped columns in group header row */}
            {!isGrouped && groupHeaderHeight > 0 && (
              <div
                className={cn(styles.columnHeaderContainer, 'bg-white', { [styles.groupBorder]: hasGroupBorder })}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: virtualColumn.start,
                  width: dimensions.cellWidth,
                  height: groupHeaderHeight,
                }}
              />
            )}
            <DataTableColumnHeader
              columnIndex={columnIndex}
              positionOffset={{
                x: virtualColumn.start,
                y: groupHeaderHeight,
              }}
            />
          </div>
        );
      })}
    </>
  );
};
